import { gql } from '@apollo/client'

import {
  CATEGORY_FRAGMENT,
  BASIC_CARD_PRODUCT_FRAGMENT,
  PRODUCT_PRICING_FRAGMENT
} from '../fragments'

export const CATEGORY_BY_ID = gql`
  ${CATEGORY_FRAGMENT}
  ${BASIC_CARD_PRODUCT_FRAGMENT}
  ${PRODUCT_PRICING_FRAGMENT}
  query CategoryById($id: ID, $slug: String) {
    category(id: $id, slug: $slug) {
      ...CategoryFragment
      parent {
        ...CategoryFragment
        children(first: 1) {
          edges {
            node {
              ...CategoryFragment
            }
          }
        }
        parent {
          ...CategoryFragment
          children(first: 1) {
            edges {
              node {
                ...CategoryFragment
              }
            }
          }
        }
      }
      children(first: 20) {
        edges {
          node {
            ...CategoryFragment
            children(first: 6) {
              edges {
                node {
                  ...CategoryFragment
                }
              }
            }
          }
        }
      }
      topProducts(first: 20) {
        totalCount
        edges {
          node {
            ...BasicCardProductFields
            ...ProductPricingField
            category {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const CATEGORIES_QUERY = gql`
  ${CATEGORY_FRAGMENT}
  query Categories(
    $before: String
    $after: String
    $first: Int!
    $last: Int
    $filter: CategoryFilterInput
  ) {
    categories(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
    ) {
      edges {
        node {
          ...CategoryFragment
          children(first: 6) {
            edges {
              node {
                ...CategoryFragment
                children(first: 6) {
                  edges {
                    node {
                      ...CategoryFragment
                    }
                  }
                }
              }
            }
          }
        }
        cursor
      }
      totalCount
    }
  }
`

export const WISHLIST_CATEGORIES_QUERY = gql`
  ${CATEGORY_FRAGMENT}
  query WishlistCategories(
    $before: String
    $after: String
    $first: Int!
    $last: Int
    $filter: CategoryFilterInput
  ) {
    wishlistCategories(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
    ) {
      edges {
        node {
          ...CategoryFragment
        }
        cursor
      }
      totalCount
    }
  }
`

export const CATEGORIES_QUERY_GLOBAL_SEARCH = gql`
  ${CATEGORY_FRAGMENT}
  query CategoriesGlobalSearch(
    $before: String
    $after: String
    $first: Int!
    $last: Int
    $filter: CategoryFilterInput
  ) {
    categoriesGlobalSearch(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
    ) {
      edges {
        node {
          ...CategoryFragment
          children(first: 6) {
            edges {
              node {
                ...CategoryFragment
                children(first: 6) {
                  edges {
                    node {
                      ...CategoryFragment
                    }
                  }
                }
              }
            }
          }
        }
        cursor
      }
      totalCount
    }
  }
`

export const CATALOGUES_QUERY = gql`
  {
    categories(first: 100, level: 0) {
      edges {
        node {
          id
          name
          backgroundImage {
            url
            alt
          }
          children(first: 20) {
            edges {
              node {
                id
                name
                children(first: 20) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
